<template>
  <div class="companyprofile">
    <div class="companyprofile-img">
      <img src="@/assets/companyprofilepic/cp-1.jpg" />
    </div>
    <div class="companyprofile-text">
      <div class="companyprofile-text-up">
        <div class="companyprofile-h1">
          <div class="companyprofile-top"></div>
          <h1>{{ $t("companyprofile") }}</h1>
        </div>
        <div>
          <div class="companyprofile-span">
            <span>
              {{ $t("companyprofileText1") }}
            </span>
          </div>
          <div class="companyprofile-span">
            <span>
              {{ $t("companyprofileText2") }}
            </span>
          </div>
        </div>
      </div>
      <div class="companyprofile-text-down">
        <div class="companyprofile-text-down-box" data-aos="fade-right">
          <div class="companyprofile-text-down-box-h1">
            <h1 v-scroll-number="{ end: 2800, duration: 500 }">2800</h1>
            <h1>M²</h1>
          </div>
          <div class="companyprofile-text-down-box-span">
            <span>
              {{ $t("companyprofileBox1") }}
            </span>
          </div>
        </div>
        <div class="companyprofile-text-down-box" data-aos="fade-up">
          <div class="companyprofile-text-down-box-h1">
            <h1 v-scroll-number="{ end: 10, duration: 500 }">10</h1>
            <h1>{{ $t("year") }}＋</h1>
          </div>
          <div class="companyprofile-text-down-box-span">
            <span>
              {{ $t("companyprofileBox2") }}
            </span>
          </div>
        </div>
        <div
          :class="{ 'companyprofile-text-down-box': 'box-none' }"
          data-aos="fade-left"
        >
          <div class="companyprofile-text-down-box-h1">
            <h1 v-scroll-number="{ end: 20, duration: 500 }">20</h1>
            <h1>＋</h1>
          </div>
          <div class="companyprofile-text-down-box-span">
            <span>
              {{ $t("companyprofileBox3") }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import scrollNumber from "@/components/scrollNumber.js";
export default {
  name: "CompanyProfile",
  directives: {
    scrollNumber,
  },
};
</script>

<style scoped>
.companyprofile {
  display: grid;
  grid-template-columns: 2fr 3fr;
  grid-gap: 1vw;
  padding: 100px 18% 50px 18%;
  background: linear-gradient(to bottom, #f4f4f4, #fff);
}

.companyprofile-img {
  /* max-width: 500px; */
  width: 100%;
}

.companyprofile-img img {
  width: 100%;
  height: auto;
  border-radius: 10px;
}

.companyprofile-text {
  display: grid;
  grid-template-rows: auto auto;
  grid-gap: 20px;
}

.companyprofile-text-up {
  padding: 0 2vw;
}

.companyprofile-top {
  height: 5px;
  background-color: #018fd7;
  margin-left: 93%;
  border-radius: 5px;
  margin-bottom: 10px;
}

.companyprofile-h1 h1 {
  margin-top: 0;
  text-align: right;
}

.companyprofile-span {
  text-align: left;
  line-height: 1.7;
  text-indent: 2em;
}

.companyprofile-text-down {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
  margin-top: 20px;
}

.companyprofile-text-down-box {
  border-top: 2px solid #018fd7;
  box-shadow: 8px 8px 15px #00000040;
  height: 130px;
}

.companyprofile-text-down-box-h1 {
  color: #018fd7;
  text-align: center;
  display: grid;
  grid-template-columns: auto auto;
  justify-content: center;
  align-items: center;
}

.companyprofile-text-down-box-h1 h1 {
  margin-bottom: 0;
  margin-top: 1rem;
  font-size: 1.5vw;
}

.companyprofile-text-down-box-span {
  padding: 5px 10px 10px 10px;
  text-align: center;
}

.companyprofile-text-down-box-span span {
  font-size: 0.8vw;
}

@media (max-width: 1000px) {
  .companyprofile-text-down-box-h1 h1 {
    font-size: 1.8vw;
  }

  .companyprofile-text-down-box-span span {
    font-size: 1.3vw;
  }
}

@media (max-width: 768px) {
  .companyprofile {
    grid-template-columns: 1fr;
  }

  .companyprofile-img {
    padding-right: 0;
    justify-content: center;
  }

  .companyprofile-text {
    padding-left: 0;
  }

  .companyprofile-text-down {
    grid-template-columns: 1fr;
  }

  .companyprofile-text-down-box-h1 h1 {
    font-size: 5vw;
  }

  .companyprofile-text-down-box-span span {
    font-size: 2.6vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/products/CompanyProfile.vue